import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../language/keys';
import { useGetAssociatedCompanyLinkedin } from '../../hooks/useAccount';
import { AccountLinkedinContainer } from './AccountLinkedinContainer';
import DialogContent from './AccountLinkedinContainer/AccountLinkedinDialogContent';

type AddAccountLinkedinDialogProps = {
  onCompanyReady: (company: Company) => void,
  isShowDialog: boolean,
  linkedinUrl: string,
  onLinkedinValueChange: (e:React.ChangeEvent<HTMLInputElement>) => void,
  onCancelClick: () => void,
}

export const AddAccountLinkedinDialog = ({
  onCompanyReady,
  isShowDialog,
  linkedinUrl,
  onLinkedinValueChange,
  onCancelClick,
}:AddAccountLinkedinDialogProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const {
    error,
    isError,
    isLoading,
    mutateAsync,
    reset,
  } = useGetAssociatedCompanyLinkedin((company: Company) => {
    onCompanyReady(company);
  });

  const actionBtnObj = {
    textBtn: translate(STRING_KEYS.CONTINUE),
    color: 'primary',
  } as const;

  const handleLinkedinValueChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    reset();
    onLinkedinValueChange(e);
  };

  return (
    <AccountLinkedinContainer
      titleHeader={ translate(STRING_KEYS.CREATE_NEW_ACCOUNT) }
      onCloseClick={ onCancelClick }
      onActionClick={ () => {
        mutateAsync(linkedinUrl);
      } }
      isShowDialog={ isShowDialog }
      textBtn={ actionBtnObj.textBtn }
      color={ actionBtnObj.color }
      disabled={ isError || linkedinUrl.trim() === '' || isLoading }
    >
      <DialogContent
        linkedinUrl={ linkedinUrl }
        onLinkedInValueChanged={ handleLinkedinValueChange }
        label={ translate(STRING_KEYS.ACCOUNTS_ASSOCIATED_COMPANY) }
        isLoading={ isLoading }
        error={ isError ? error : null }
      />
    </AccountLinkedinContainer>
  );
};
